import {
  Table,
  TableBody,
  TableRow,
} from "@/components/ui/table"
import { getCoreRowModel, useReactTable } from "@tanstack/react-table"
import { ColumnMetaData, TableDataProps } from "@/types/types"
import { TableHeaderComponent } from "@/components/custom/Table/TableHeader"
import { EmptyTableRow } from "@/components/custom/Table/EmptyTableRow"
import { WorkflowExecution } from "@/types/workflowHistory"
import { useNavigate, useLocation } from "react-router-dom"
import { CustomTableCell } from "@/components/custom/Table/TableCell"
import { WorkflowRunStatusType } from "@/constants/workflowHistory/workflowHistory"
import { TableCellType } from "@/constants/table/table"

export const WorkflowsExecutionHistoryTable = ({
  columns,
  data,
}: TableDataProps<WorkflowExecution>
) => {
  const navigate = useNavigate()
  const location = useLocation()
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <div className="rounded-md border w-full">
      <Table>
        <TableHeaderComponent data={data} columns={columns} />
        <TableBody className="text-primary">
          {table.getRowModel().rows.length ? (
            table.getRowModel().rows.map((row) => (
              <TableRow
                key={row.id}
                data-state={row.getIsSelected() && "selected"}
                className="bg-primary-foreground hover:bg-border/5 hover:cursor-auto"
              >
                {row.getVisibleCells().map((cell) => (
                  <CustomTableCell
                    key={cell.id}
                    cell={cell}
                    onClick={cell.getContext().row.original.status !== WorkflowRunStatusType.READY ? () => {
                      if ((cell.column.columnDef.meta as ColumnMetaData)?.type === TableCellType.LINK_BUTTON) {
                        navigate(`${location.pathname}/${cell.getContext().row.original.id}/details`)
                      }
                    } : undefined}
                  />
                ))}
              </TableRow>
            ))
          ) : (
            <EmptyTableRow numberOfColumns={columns.length} />
          )}
        </TableBody>
      </Table>
    </div>
  )
}
